import { KeyConfigurations } from '@enums/KeyConfigurations';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { MotionButton } from '@shared/atoms/MotionButton/MotionButton';
import React from 'react';
import { SystemButton } from '@shared/molecules/SystemButton/SystemButton';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import styles from './index.module.scss';

interface QuestionNavigationProps {
  onPrevious: () => void;
  onNext: () => void;
  showPrevious: boolean;
  className?: string;
  currentQuestionNumber?: number;
  totalQuestions?: number;
}

export const QuestionNavigation: React.FC<QuestionNavigationProps> = ({
  onPrevious,
  onNext,
  showPrevious,
  className,
  currentQuestionNumber,
  totalQuestions,
}) => {
  const navigationStatus =
    totalQuestions && currentQuestionNumber
      ? `Question ${currentQuestionNumber} of ${totalQuestions}`
      : '';

  return (
    <div className={className}>
      {showPrevious && (
        <MotionButton
          onClick={onPrevious}
          className={styles.backBtn}
          aria-label="Go to previous question"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === KeyConfigurations.ENTER || e.key === KeyConfigurations.SPACE) {
              e.preventDefault();
              onPrevious();
            }
          }}
        >
          <ArrowBackIcon aria-hidden="true" />
        </MotionButton>

        // <SystemButton
        //   onClick={onPrevious}
        //   disabled={currentQuestionNumber === 0}
        //   variant="outlinedPrimarySkyBlue"
        //   onKeyDown={(e: { key: KeyConfigurations; preventDefault: () => void }) => {
        //     if (e.key === KeyConfigurations.ENTER || e.key === KeyConfigurations.SPACE) {
        //       e.preventDefault();
        //       onPrevious();
        //     }
        //   }}
        // >
        //   <NavigateBeforeIcon aria-hidden="true" />
        //   Previous &nbsp;
        // </SystemButton>
      )}

      {navigationStatus && (
        <div className="visually-hidden" aria-live="polite">
          {navigationStatus}
        </div>
      )}
      {/* <MotionButton onClick={onNext}>Continue</MotionButton> */}
    </div>
  );
};

QuestionNavigation.defaultProps = {
  className: styles.navigationButtons,
  currentQuestionNumber: undefined,
  totalQuestions: undefined,
};
